export default "/images/vendor/flag-icon-css/flags/1x1/mp.svg?b0a5ed44db6410228f23d1f2676aeded";